import { manta as viemManta } from 'viem/chains';

import { defaultServices } from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const manta = {
  displayName: 'Manta Pacific',
  runtime: 'evm',
  viemChain: viemManta,
  isSupported: false,
  isMainnet: true,
  services: defaultServices({
    zerion: { chainKey: 'manta-pacific' },
  }),
} as const satisfies AllChainConfig<'evm', false>;
